export default hasAdminPrivileges => {
  return hasAdminPrivileges
    ? {
        urlMixerBert: "",
        urlRemoteProduction: "",
        elasticIp: "",
        eventStatus: undefined,
      }
    : {};
};
